$(function () {
  // 购物车弹窗
  let CartDrawer = class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.cartItemCount = 0;
      this.removeEventId = null;
      this.$body = $('body');
      this.isOpen = false;

      // 先绑定所有方法到实例
      this.handlequantityChange2 = this.handlequantityChange2.bind(this);
      this.handleRemoveItem = this.handleRemoveItem.bind(this);
      this.updateCartQuantity = this.updateCartQuantity.bind(this);
      this.close = this.close.bind(this);
      this.init = this.init.bind(this);
      this.bindRemoveButtons = this.bindRemoveButtons.bind(this);
      this.bindCloseButton = this.bindCloseButton.bind(this);

      this.init();
      // 监听点击背景关闭事件
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    bindCloseButton() {
      const closeButton = this.querySelector('#closeButton');
      if (closeButton) {
        // 移除可能存在的旧事件监听器
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        newCloseButton.addEventListener('click', this.close);
      }
    }

    init() {
      this.bindEvents();
      this.initSubtotalToggle();
      this.addPurchaseProductItem();
      this.initCartConnt();
      this.initCartPopupInfo();
      this.bindRemoveButtons();
      this.bindCloseButton();
    }

    disconnectedCallback() {
      window.overlayManager.hide(); // 组件销毁时清理遮罩层
      window.removeEventListener('cartquantityChange2', this.handlequantityChange2);
    }
    initCartPopupInfo() {
      const messagePopup = document.querySelector('.message-popup');
      const discountPopup = document.querySelector('.cart-popup');
      const messagePopupIcon = document.querySelectorAll('.message-popup-icon');
      const discountPopupIcon = document.querySelectorAll('.discount-popup-icon');
      const $discountCode = $(this.querySelector('#discount-code'));
      const discount = window.localStorage.getItem('discountCode');
      if (discount) {
        if (discount) {
          discountPopupIcon.forEach((icon) => {
            icon.classList.add('active-icon');
          });
        }
        if (window.innerWidth > 768) {
          // this.querySelector('.empty-handle-container').classList.add('hidden');
          // this.querySelector('.full-handle-container').classList.remove('hidden');
        }
        if (window.localStorage.getItem('discountCode')) {
          document.querySelector('.discount-content').innerHTML = window.localStorage.getItem('discountCode');
        }
      }
    }
    initCartConnt() {
      const cartIconBubble = document.querySelector('#cart-icon-bubble .absolute');
      if (cartIconBubble) {
        // 获取购物车数量
        const cartCount = parseInt(cartIconBubble.textContent) || 0;

        // 如果购物车为空，添加 hidden 类
        if (cartCount === 0) {
          cartIconBubble.classList.add('hidden');
          cartIconBubble.innerHTML = '';
        } else {
          cartIconBubble.classList.remove('hidden');
          cartIconBubble.innerHTML =
            cartCount >= 99 ? '<div class="leading-[8px]">99+</div>' : `<div class="leading-[8px]">${cartCount}</div>`;
        }
      }
    }
    bindEvents() {
      window.addEventListener('cartquantityChange2', this.handlequantityChange2);
    }

    handlequantityChange2(event) {
      this.updateCartQuantity(event.detail);
    }
    overlayMask(flag) {
      requestAnimationFrame(() => {
        if (flag) {
          // 使用全局遮罩层管理器
          this.$overlay = window.overlayManager.show();
          // 使用 jQuery 绑定点击事件
          this.$overlay.on('click', (event) => {
            event.preventDefault();
            this.close();
          });
        } else {
          window.overlayManager.hide(); // 使用全局遮罩层管理器
        }
      });
    }
    handleRemoveItem(event) {
      const button = event.currentTarget;
      const itemId = button.closest('[data-id]')?.dataset.id;

      if (itemId) {
        // 触发数量更新事件，设置数量为0来删除商品
        const removeEvent = {
          id: itemId,
          value: 0,
        };
        this.updateCartQuantity(removeEvent, 'remove');
      }
    }
    loadingAnimation(flag) {
      if (flag) {
        const newLoadingElement = this.querySelector('.global-loading');
        newLoadingElement.classList.add('active');
        newLoadingElement.classList.remove('hidden');
      } else {
        // 隐藏 loading，使用过渡效果
        const newLoadingElement = this.querySelector('.global-loading');
        newLoadingElement.classList.remove('active');
        // 等待过渡完成后再添加 hidden 类
        setTimeout(() => {
          newLoadingElement.classList.add('hidden');
        }, 300); // 与 CSS 过渡时间相匹配      // 隐藏 loading，使用过渡效果
      }
    }
    async updateCartQuantity(event, type = 'update') {
      this.loadingAnimation(true);
      try {
        let productElement = this.querySelector('.product-' + event.id);
        this.removeEventId = event.id;
        const response = await fetch(`/cart/change.js`, {
          body: JSON.stringify({
            id: event.id,
            quantity: event.value,
            sections: 'cart-drawer,cart-icon-bubble',
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const cartContent = await response.json();
        await updateCartComponents(cartContent);

        this.loadingAnimation(false);
      } catch (error) {
        console.error('error', error);
      }
    }
    async getCartContent() {}
    showMessage(message) {
      const toast = document.createElement('div');
      toast.innerText = message;
      toast.style.visibility = 'hidden';
      toast.style.minWidth = '7.5rem';
      toast.style.backgroundColor = '#666666';
      toast.style.color = '#fff';
      toast.style.textAlign = 'center';
      toast.style.borderRadius = '0.5rem';
      toast.style.padding = '0.63rem 1.5rem';
      toast.style.position = 'fixed';
      toast.style.zIndex = '900';
      toast.style.left = '50%';
      toast.style.top = '50%';
      toast.style.fontSize = '1rem';
      toast.style.transform = 'translate(-50%, -50%)';

      // 添加到文档中
      document.body.appendChild(toast);

      // 显示吐司
      toast.style.visibility = 'visible';

      // 2秒后隐藏并移除吐司
      setTimeout(() => {
        toast.style.visibility = 'hidden';
        document.body.removeChild(toast);
      }, 2000);
    }
    // 添加一个格式化金额的辅助方法
    formatMoney(cents) {
      return '$' + cents.toFixed(2);
    }
    async addPurchaseProductItem() {
      const purchaseProductItem = this.querySelector('.purchase-product-item');
      let variantId = null;
      if (purchaseProductItem) {
        variantId = purchaseProductItem.getAttribute('data-variant-id');
      }

      customEventListener(purchaseProductItem, 'click', async () => {
        this.loadingAnimation(true);

        if (variantId) {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                // 添加当前产品
                {
                  id: parseInt(variantId),
                  quantity: 1,
                },
              ],
              sections: 'cart-drawer,cart-icon-bubble',
            }),
          });
          if (window.gtag) {
            gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
          }
          this.loadingAnimation(false);

          if (response.ok) {
            const cartContent = await response.json();
            await updateCartComponents(cartContent);
          }
          if (!response.ok) {
            window.GlobalPrompt.show(window.i18n.noStock, 'error');
            return;
          }
        }
      });
    }
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      const closeButton = this.querySelector('#closeButton');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      // 点击触发显示购物车
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.location.href.includes('cart')) {
          window.location.href = '/cart';
        } else {
          this.open(cartLink);
        }
      });
      // 点击关闭按钮关闭弹窗
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    }
    async open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // 移除隐藏类并添加 open 属性
      this.classList.remove('cart-drawer-close');
      this.setAttribute('open', 'true');
      this.overlayMask(true);
      this.$body.addClass('drawer-body-no-scroll');
    }

    close() {
      // 移除 open 属性
      this.removeAttribute('open');
      this.classList.add('cart-drawer-close');
      this.$body.removeClass('drawer-body-no-scroll');
      this.overlayMask(false);
      window.overlayManager.hide(); // 确保关闭时也清理遮罩层

      // 添加隐藏类

      // 确保关闭事件正确绑定
      const closeButton = this.querySelector('#closeButton');
      const shadowMask = this.querySelector('#shadowMask');

      if (closeButton) {
        closeButton.removeEventListener('click', this.close.bind(this));
        closeButton.addEventListener('click', this.close.bind(this));
      }

      if (shadowMask) {
        shadowMask.removeEventListener('click', this.close.bind(this));
        shadowMask.addEventListener('click', this.close.bind(this));
      }
    }

    renderContents(parsedState) {
      const drawerInner = this.querySelector('.drawer__inner');

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = this.querySelector(section.selector);
        if (!sectionElement) return;

        const newContent = this.getSectionDOM(parsedState.sections[section.id], section.selector);
        if (newContent) {
          sectionElement.replaceChildren(...newContent.childNodes);
        }
      });

      setTimeout(() => {
        this.open();
      });
    }

    getSectionDOM(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector);
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    getSectionsToRender() {
      return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
    }

    initSubtotalToggle() {
      const subtotalContainer = this.querySelector('.subtotal-container');
      if (!subtotalContainer) return;

      const arrowIcon = document.querySelector('.arrow-icon-cart');
      const detailsPanel = subtotalContainer.querySelector('.subtotal-details');

      subtotalContainer.addEventListener('click', () => {
        detailsPanel.classList.toggle('hidden');
        arrowIcon.classList.toggle('rotate-180');
      });
    }

    bindRemoveButtons() {
      // 先移除所有旧的事件监听器
      this.querySelectorAll('.icon-close').forEach((button) => {
        button.removeEventListener('click', this.handleRemoveItem);
        button.addEventListener('click', this.handleRemoveItem);
      });
    }
  };

  let CartInputNumber = class CartInputNumber extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initInputNumber();
    }

    initInputNumber() {
      const $input = $(this.querySelector('input'));
      const $input_number_minus = $(this.querySelector('.input-number_minus'));
      const $input_number_plus = $(this.querySelector('.input-number_plus'));

      // 处理输入
      $input.on('blur', () => {
        const max = $input.attr('max');
        const id = $input.attr('id');
        let value = parseInt($input.val());

        if (value < 1) value = 1;
        if (value > max) value = max;
        if (value == 0 || value == null || value == undefined || isNaN(value) || value == '') {
          value = 1;
        }
        $input.val(value);
        this.triggerquantityChange2(value, id);
      });

      // 减少数量
      $input_number_minus.on('click', () => {
        const id = $input.attr('id');
        if ($input.val() > 1) {
          const newValue = +$input.val() - 1;
          $input.val(newValue);
          this.triggerquantityChange2(newValue, id);
        }
      });

      // 增加数量
      $input_number_plus.on('click', () => {
        const id = $input.attr('id');
        const max = $input.attr('max');
        if ($input.val() < +max) {
          const newValue = +$input.val() + 1;
          this.triggerquantityChange2(newValue, id);
          $input.val(newValue);
          const event = new CustomEvent('quantityChange2', { detail: $input.val() });
          window.dispatchEvent(event); // 触发事件
        } else {
          // 获取data-message
          const message = $input.attr('data-message');
          window.GlobalPrompt.show(message, 'error');
        }
      });
    }

    triggerquantityChange2(value, id) {
      const event = new CustomEvent('cartquantityChange2', {
        bubbles: true,
        detail: {
          id: id,
          value: value,
        },
      });
      window.dispatchEvent(event);
    }
  };
  let CartPopupMessage = class CartPopupMessage extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initCartPopupMessage();
      this.bindEvents();
    }

    initCartPopupMessage() {
      const messagePopup = this.querySelector('.message-popup');
      const messageTextarea = messagePopup.querySelector('#special-instructions');
      const charCount = messagePopup.querySelector('#char-count');
      const maxLength = messageTextarea.getAttribute('maxlength');

      // 初始化字符计数
      const currentLength = messageTextarea.value.length;
      // charCount.textContent = `${currentLength}/${maxLength}`;

      // 监听输入事件
      messageTextarea.addEventListener('input', () => {
        const currentLength = messageTextarea.value.length;
        // charCount.textContent = `${currentLength}/${maxLength}`;
      });
    }

    bindEvents() {
      // 打开留言弹窗
      const messagePopupBtns = document.querySelectorAll('#message-popup');
      const messageContentContainer = document.querySelector('.message-content');
      const messagePopup = this.querySelector('.message-popup');
      const cancelBtn = this.querySelector('.cancel-btn');
      const saveBtn = this.querySelector('.save-btn');
      const $textarea = $(this.querySelector('#special-instructions'));
      if ($textarea.val() == '') {
        saveBtn.disabled = true;
      } else {
        saveBtn.disabled = false;
      }
      messagePopupBtns.forEach((button) => {
        button.addEventListener('click', () => {
          messagePopup.setAttribute('open', '');
          messagePopup.classList.remove('cart-drawer-close');
          //收回subtotal-details
          const subtotalContainer = document.querySelector('.subtotal-container');
          const subtotalDetails = subtotalContainer.querySelector('.subtotal-details');
          subtotalDetails.classList.add('hidden');

          $textarea.on('input', () => {
            if ($textarea.val() == '') {
              saveBtn.disabled = true;
            } else {
              saveBtn.disabled = false;
            }
          });
        });
      });

      // 关闭留言弹窗
      cancelBtn?.addEventListener('click', () => {
        messagePopup.removeAttribute('open');

        messagePopup.classList.add('cart-drawer-close');
        setTimeout(() => {
          document.querySelector('.cart-popup-discount').classList.add('z-[-1]');
        }, 700);
      });

      saveBtn?.addEventListener('click', async () => {
        const $textarea = $(this.querySelector('#special-instructions'));
        const messageContent = $textarea.val();
        const response = await fetch(`/cart/update`, {
          body: JSON.stringify({ note: messageContent }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (response.ok) {
          messagePopup.removeAttribute('open');
          messagePopup.setAttribute('data-note', messageContent);
          messageContentContainer.innerHTML = messageContent;
          messagePopup.classList.add('cart-drawer-close');

          const messagePopupIcon = document.querySelectorAll('.message-popup-icon');
          messagePopupIcon.forEach((icon) => {
            icon.classList.add('active-icon');
          });
        }
      });
    }
  };

  let CartPopupDiscount = class CartPopupDiscount extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.bindEvents();
    }

    bindEvents() {
      // 打开优惠券弹窗
      const discountPopupBtns = document.querySelectorAll('#discount-popup');
      const discountContentContainer = document.querySelector('.discount-content');
      const discountPopup = this.querySelector('.cart-popup');
      const cancelBtn = this.querySelector('.cancel-btn');
      const saveBtn = this.querySelector('.save-btn-discount');
      const $discountCode = $(this.querySelector('#discount-code'));
      const discountCodeButton = document.querySelector('.message-edit2');
      const discountPopupContainer = document.querySelector('.discount-popup-container');
      const discountPopupContainerDefaultText = document.querySelector('.discount-popup-container-default-text');
      console.log('$discountCodeButton222', discountCodeButton);
      const discount = window.localStorage.getItem('discountCode');
      if (discount) {
        discountPopupContainer.classList.add('discount-popup-container-open');
        discountPopupContainerDefaultText.style.display = 'none';
        discountCodeButton.style.display = 'block';
        $discountCode.val(discount);
      } else {
        discountPopupContainer.classList.remove('discount-popup-container-open');
        discountPopupContainerDefaultText.style.display = 'block';
        $discountCode.val('');
        discountCodeButton.style.display = 'none';
      }
      discountPopupBtns.forEach((button) => {
        button.addEventListener('click', () => {
          document.querySelector('.cart-popup-discount').classList.remove('z-[-1]');
          discountPopup.classList.remove('cart-drawer-close');
          if (document.querySelector('.subtotal-container')) {
            const subtotalContainer = document.querySelector('.subtotal-container');
            const subtotalDetails = subtotalContainer.querySelector('.subtotal-details');
            subtotalDetails.classList.add('hidden');
          }
          discountPopup.setAttribute('open', '');
          const discount = window.localStorage.getItem('discountCode');
          if (discount) {
            discountPopupContainer.classList.add('discount-popup-container-open');
            discountPopupContainerDefaultText.style.display = 'none';
            discountCodeButton.style.display = 'block';
            $discountCode.val(discount);
          } else {
            discountPopupContainer.classList.remove('discount-popup-container-open');
            discountPopupContainerDefaultText.style.display = 'block';
            $discountCode.val('');
            discountCodeButton.style.display = 'none';
          }

          if ($discountCode.val() == '') {
            saveBtn.disabled = true;
          }
          $discountCode.on('input', () => {
            if ($discountCode.val() == '') {
              saveBtn.disabled = true;
            } else {
              saveBtn.disabled = false;
            }
          });
        });
      });

      // 关闭优惠券弹窗
      cancelBtn?.addEventListener('click', () => {
        discountPopup.removeAttribute('open');
        discountPopup.classList.add('cart-drawer-close-2');
        setTimeout(() => {
          document.querySelector('.cart-popup-discount').classList.add('z-[-1]');
        }, 700);
      });

      saveBtn?.addEventListener('click', async () => {
        discountPopup.removeAttribute('open');
        discountPopup.classList.add('cart-drawer-close-2');
        setTimeout(() => {
          document.querySelector('.cart-popup-discount').classList.add('z-[-1]');
        }, 700);
        const $discountCode = $(this.querySelector('#discount-code'));

        let discountCode = $discountCode.val();

        window.localStorage.setItem('discountCode', discountCode);
        discountContentContainer.innerHTML = discountCode;
        const discountPopupContainer = document.querySelector('.discount-popup-container');
        const discountPopupContainerDefaultText = document.querySelector('.discount-popup-container-default-text');
        const discountCodeButton = document.querySelector('.message-edit2');

        discountPopup.setAttribute('data-discount', discountCode);

        const discountPopupIcon = document.querySelectorAll('.discount-popup-icon');
        discountPopupIcon.forEach((icon) => {
          icon.classList.add('active-icon');
        });
        if (discountCode) {
          discountCode = encodeURIComponent(discountCode);
          discountPopupContainer.classList.add('discount-popup-container-open');
          discountPopupContainerDefaultText.style.display = 'none';
          discountCodeButton.style.display = 'block';
          $discountCode.val(discount);
        } else {
          discountPopupContainer.classList.remove('discount-popup-container-open');
          discountPopupContainerDefaultText.style.display = 'block';
          $discountCode.val('');
          discountCodeButton.style.display = 'none';
        }
        // 保存逻辑...
        // 获取留言内容
        const couponRes = await fetch(`/discount/${discountCode}`);
        const text1 = await couponRes.text();
      });
    }
  };

  // 注册自定义元素
  window.customElements.define('cart-drawer', CartDrawer);
  window.customElements.define('cart-input-number', CartInputNumber);
  window.customElements.define('cart-popup-message', CartPopupMessage);
  window.customElements.define('cart-popup-discount', CartPopupDiscount);
  window.customElements.define(
    'cart-icon-bubble',
    class CartIconBubble extends HTMLElement {
      constructor() {
        super();
      }

      updateBubble(itemCount) {
        const bubble = this.querySelector('.absolute.-top-[12px].-right-[12px]');
        if (!bubble) return;

        if (itemCount === 0) {
          bubble.classList.add('hidden');
          bubble.innerHTML = '';
        } else {
          bubble.classList.remove('hidden');
          bubble.innerHTML = `
            <div class="text-[14px] rounded-full bg-[#ea5504] text-white p-[6px]">
              <div class="leading-[8px]">${itemCount >= 99 ? '99+' : itemCount}</div>
            </div>
          `;
        }
      }
    }
  );
});
